import { render, staticRenderFns } from "./transcription-sub-table.vue?vue&type=template&id=7956cd82&lang=pug&"
import script from "./transcription-sub-table.vue?vue&type=script&lang=ts&"
export * from "./transcription-sub-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports